import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { stringify } from "query-string";
import { useUser } from "../contexts/user";
import Spinner from "../components/Spinner";

const PrivateRoute = ({ authPath = "/signin", ...props }) => {
  const { user, loading } = useUser();
  if (loading) {
    return <Spinner size="l" />;
  }
  if (user) {
    return <Route {...props} />;
  }
  const {
    history: {
      location: { pathname, search, hash },
    },
  } = props;
  const returnUrl = `${pathname}${search}${hash}`;
  return (
    <Redirect
      to={{ pathname: authPath, search: stringify({ r: returnUrl }) }}
    />
  );
};

export default withRouter(PrivateRoute);
